import { useMutation } from "@apollo/react-hooks";
import { Modal } from "@shopify/polaris";
import React from "react";
import { REVOKE_ACCESS_TIKTOK_PRODUCT_TEMPLATE } from "../../../graphql/mutations";
import { useToastContext } from "../../shared/ToastContext";
import { useSelectRowsCtx } from "../../shared/SelectRow";
import { arrInvalid, handleError } from "../../../helper";
import { useProductTemplateAccessLevel } from "./product-template-access-level-ctx";

export default function ProductTemplateUserAccessRevoke({ open, onClose }) {
  const { setNotify, toggleToast } = useToastContext();
  const { ids, onCompleted } = useSelectRowsCtx();
  const { refetch } = useProductTemplateAccessLevel();

  const [revokeAccess, { loading }] = useMutation(
    REVOKE_ACCESS_TIKTOK_PRODUCT_TEMPLATE,
    {
      onCompleted: () => {
        setNotify({
          msg: "Revoke access for this Template success",
          err: false,
        });
        onCompleted && onCompleted();
        refetch && refetch();
      },
      onError: (err) => {
        setNotify({ msg: handleError(err?.toString), err: true });
      },
    },
  );

  const handleSubmit = React.useCallback(() => {
    if (arrInvalid(ids)) return;

    toggleToast(true);
    setNotify({ msg: null, err: false });

    revokeAccess({
      variables: {
        ids,
      },
    });
  }, [revokeAccess, ids]);

  return (
    <Modal
      title="Revoke Access Template"
      open={open}
      onClose={onClose}
      primaryAction={{
        content: "Submit",
        onAction: handleSubmit,
        loading: loading,
      }}
      secondaryActions={[{ content: "Cancel", onaction: onClose }]}
      sectioned
    >
      <p>Are you sure to revoke access this template?</p>
    </Modal>
  );
}
